import { classNames } from "../App";


export default function CustomButton({ className, onClick, children, type }) {
    return <button className={classNames(className,
        'font-poppins font-semibold text-white bg-accent_green rounded-xl px-4 py-2 text-base'
    )} onClick={onClick} type={type || 'button'}>{children}</button>
}